import React, { memo, useEffect, useState } from 'react'
import { WHITE } from '../../../colors'
import { useLazyQuery } from '@apollo/client'
import { LIVE_EVENTS } from '../query/sgc'
import { Box, CircularProgress } from '@mui/material'
import { Trans } from 'react-i18next'
import { importantDate } from '../Components/ImportantNotes'
import MobileResources from '../Components/MobileResources'

const SgcMobilePage = () => {
  const [events, setEvents] = useState([])

  const [getLiveEvents, { loading }] = useLazyQuery(LIVE_EVENTS, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      if (err?.message?.length) {
        console.error('Invalid Request')
      }
    },
    onCompleted (payload) {
      const { liveEvents } = payload
      if (liveEvents) {
        setEvents([...liveEvents].sort((ev1, ev2) => ev1?.startOn - ev2?.startOn))
      }
    }
  })

  useEffect(() => {
    getLiveEvents({ variables: { season: null } })
  }, [getLiveEvents])

  return (
    <div style={{ color: WHITE, padding: 20 }}>
      <Box>
        <div>
          <h3 id='unstyled-modal-title' className='modal-title'>
            <Trans i18nKey='sgc.tab.importantdates'>IMPORTANT DATES</Trans>
          </h3>
          <ul style={{ lineHeight: 2 }}>
            {importantDate.map(data =>
              <li key={data.date}><span style={{ fontWeight: 'bold' }}>{data.date}:</span>&nbsp;{data.description}</li>
            )}
          </ul>
        </div>
      </Box>
      <h3 id='unstyled-modal-title' className='modal-title'>
        <Trans i18nKey='sgc.events.info.title'>In-person Event Dates</Trans>
      </h3>
      {loading
        ? <CircularProgress size={3} />
        : (
          <ul style={{ lineHeight: 2 }}>
            {events.map(data =>
              <li key={data.id}>
                <span style={{ fontWeight: 'bold' }}>{data.startOn.substring(0, 10)}</span>, {data.city}, {data.state}
              </li>)}
          </ul>)}
      <h3 id='unstyled-modal-title' className='modal-title'>
        <Trans i18nKey='central.header.Resources'>Resources</Trans>
      </h3>
      <MobileResources />
    </div>
  )
}

export default memo(SgcMobilePage)
